export const LIST_TYPE = {
	COMMON: 'common',
	ANONYMOUS: 'anonymous',
	RECENT: 'recent',
	FAV: 'fav',
	ALBUM: 'album'
};

export const ARTICLE_TYPE = {
	MUST_READ_NOTICE: 'MUST_READ_NOTICE',
	NOTICE: 'NOTICE',
	NORMAL: 'NORMAL'
};

export const MAX_HEAD_CONT_COUNT = 50;
export const MAX_HEAD_CONT_BYTE = 14;
export const ADD_HEAD_CONT_RESPONSE_TYPE = {
	SUCCESS: 'S',
	EXIST: 'E',
	FAIL: 'F'
};
export const ADD_HEAD_CONT_RESPONSE_MESSAGE = {
	[ADD_HEAD_CONT_RESPONSE_TYPE.EXIST]: '이미 존재하고 있는 말머리 입니다.',
	[ADD_HEAD_CONT_RESPONSE_TYPE.FAIL]: '말머리 추가중 오류가 발생하였습니다.'
};

export const TITLE_COLORS = [
	'#000000', '#333333', '#666666', '#9d9d9d', '#dddddd', '#ffffff',
	'#ee2323', '#f89009', '#f3c000', '#0db4a0', '#006dd7', '#8a3db6', '#72889c',
	'#ffc1c8', '#ffc9af', '#f6e199', '#9feec3', '#99cefa', '#c1bef9', '#c0d1e7',
	'#ef5369', '#ef6f53', '#a6bc00', '#409d00', '#0593d3', '#6164c6', '#8cb3be',
	'#781b33', '#953b34', '#5f6d2b', '#1b711d', '#1a5490', '#5733b1', '#456771',
];
export const DEFAULT_COLOR = '#000000';
export const MIN_COLOR_LENGTH = 3;

// 공지 감추기 여부를 위한 로컬 스토리지 키
export const NOTICE_HIDDEN_KEY = 'hideNoti';

export const RESTRICTION_URL = {
	D1: '//top.cafe.daum.net/_c21_/guide?for=restriction_rule',
	D2: '//top.cafe.daum.net/_c21_/guide?for=restriction_rule',
	R2: '//cs.daum.net/redbell/right/libelGuide.html',
	R3: '//cs.daum.net/redbell/right/copyrightGuide.html',
	DEFAULT: '//cs.daum.net/redbell/right/libelGuide.html'
};

export const RESTRICTION_MESSAGE = {
	D1: '관리자에 의해 규제된 글입니다.',
	D2: '관리자에 의해 규제된 글입니다.',
	R2: '정보통신망법 제44조의2에 의해 삭제 조치된 글입니다.',
	R3: '저작권 침해 신고로 접근금지 조치된 글입니다.',
	DEFAULT: '권리 침해 신고 접수에 의해 임시 조치된 글입니다.'
};

